import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { StyledContainer } from "components/StyledContainer";
import styled from "styled-components";

export const FixedContainer = styled.a<{ $backgroundColor: string }>`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const Wrapper = styled(StyledContainer)`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  height: 88px;
  min-height: 88px;
  width: 100%;
  overflow: hidden;
`;

export const TransparentButton = styled.button`
  background: transparent;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
  padding: 8px;
  outline: none;
  box-shadow: none;
  border: none;
  z-index: 3;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    right: 0;
  }

  svg {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.ublue06};
    }
  }
`;

const GradientBase = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
  width: 88px;
  z-index: 1;

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const GradientLeft = styled(GradientBase)<{ $backgroundColor: string }>`
  background: ${({ $backgroundColor }) => `linear-gradient(
    to right,
    ${$backgroundColor} 0%,
    ${$backgroundColor} 40%,
    transparent 100%
  )`};
  left: 0;
`;

export const GradientRight = styled(GradientBase)<{ $backgroundColor: string }>`
  background: ${({ $backgroundColor }) => `linear-gradient(
    to left,
    ${$backgroundColor} 0%,
    ${$backgroundColor} 40%,
    transparent 100%
  )`};
  right: 0;
`;
